import { Svg, SvgPath, SvgProps } from '../../../components/svg';

export function LocationFilled(props: SvgProps) {
  return (
    <Svg {...props} viewBox="0 0 13 18" fill="none">
      <SvgPath
        d="M6.25 7.5C6.94036 7.5 7.5 6.94036 7.5 6.25C7.5 5.55964 6.94036 5 6.25 5C5.55964 5 5 5.55964 5 6.25C5 6.94036 5.55964 7.5 6.25 7.5Z"
        fill="#502314"
      />
      <SvgPath
        d="M6.25 0C2.80391 0 0 2.68164 0 5.97656C0 7.5457 0.715234 9.63242 2.12578 12.1789C3.25859 14.2234 4.56914 16.0723 5.25078 16.9922C5.36596 17.1494 5.51656 17.2772 5.69037 17.3653C5.86418 17.4534 6.0563 17.4993 6.25117 17.4993C6.44604 17.4993 6.63816 17.4534 6.81197 17.3653C6.98578 17.2772 7.13638 17.1494 7.25156 16.9922C7.93203 16.0723 9.24375 14.2234 10.3766 12.1789C11.7848 9.6332 12.5 7.54648 12.5 5.97656C12.5 2.68164 9.69609 0 6.25 0ZM6.25 8.75C5.75555 8.75 5.2722 8.60338 4.86107 8.32867C4.44995 8.05397 4.12952 7.66352 3.9403 7.20671C3.75108 6.74989 3.70157 6.24723 3.79804 5.76227C3.8945 5.27732 4.1326 4.83186 4.48223 4.48223C4.83186 4.1326 5.27732 3.8945 5.76227 3.79804C6.24723 3.70157 6.74989 3.75108 7.20671 3.9403C7.66352 4.12952 8.05397 4.44995 8.32867 4.86107C8.60338 5.2722 8.75 5.75555 8.75 6.25C8.74928 6.91282 8.48565 7.54828 8.01697 8.01697C7.54828 8.48565 6.91282 8.74928 6.25 8.75Z"
        fill="#502314"
      />
    </Svg>
  );
}
